module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "editfoldermodal",
    attrs: {
      "id": "edit-folder-modal",
      "name": "edit-folder-modal",
      "title": "Edit folder",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Update",
      "ok-disabled": !_vm.folderName,
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.shown,
      "ok": _vm.handleOk
    }
  }, [_c('form', {
    attrs: {
      "id": "update-folder-form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Folder name",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.folderName),
      callback: function($$v) {
        _vm.folderName = $$v
      },
      expression: "folderName"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    attrs: {
      "name": "warning"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Updating\n  ")], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-155eba40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/EditFolderModal.vue
// module id = 999
// module chunks = 1